import { render, staticRenderFns } from "./seekerItem.vue?vue&type=template&id=6965c90a&scoped=true"
import script from "./seekerItem.vue?vue&type=script&lang=js"
export * from "./seekerItem.vue?vue&type=script&lang=js"
import style0 from "./seekerItem.vue?vue&type=style&index=0&id=6965c90a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965c90a",
  null
  
)

export default component.exports